// eslint-disable-next-line import/prefer-default-export
export const slPlayerClientId = 'PTPLAYER9PLUS10';
